<div class="modal-backdrop" (click)="close.emit()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-head">
      <h5>{{ mode === 'edit' ? 'Edit Habit' : 'New Habit' }}</h5>
      <button class="close-x" type="button" (click)="close.emit()" aria-label="Close">✕</button>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label>Name</label>
        <input type="text" [(ngModel)]="form.name" placeholder="e.g. Vitamins, 20 mins cardio">
      </div>

      <div class="form-group">
        <label>Category <span class="muted">(tag for filtering)</span></label>
        <input type="text" [(ngModel)]="form.category" list="category-list" placeholder="e.g. Diet, Fitness, Brain">
        <datalist id="category-list">
          <option *ngFor="let cat of existingCategories" [value]="cat"></option>
        </datalist>
      </div>

      <div class="form-group">
        <label>Frequency</label>
        <div class="radio-row">
          <label class="radio-label">
            <input type="radio" name="frequency" value="daily" [(ngModel)]="form.frequency"> Daily
          </label>
          <label class="radio-label">
            <input type="radio" name="frequency" value="weekly" [(ngModel)]="form.frequency"> Weekly
          </label>
        </div>
      </div>

      <div class="form-group" *ngIf="form.frequency === 'weekly'">
        <label>Target per week</label>
        <input type="number" [(ngModel)]="form.target" min="1" max="7">
      </div>

      <div *ngIf="formError" class="form-error">{{ formError }}</div>

      <div *ngIf="mode === 'edit' && archivedHabits.length" class="archived-section">
        <button type="button" class="archived-toggle" (click)="showArchived = !showArchived">
          {{ showArchived ? '▾' : '▸' }} Show {{ archivedHabits.length }} archived habit{{ archivedHabits.length === 1 ? '' : 's' }}
        </button>
        <div *ngIf="showArchived" class="archived-list">
          <div *ngFor="let h of archivedHabits" class="archived-row">
            <div class="archived-info">
              <span class="archived-name">{{ h.name }}</span>
              <span *ngIf="h.category" class="archived-tag">{{ h.category }}</span>
              <span class="archived-freq">{{ h.frequency }}</span>
            </div>
            <div class="archived-actions">
              <button type="button" class="link-btn" (click)="doUnarchive(h.id)">Unarchive</button>
              <button type="button" class="link-btn danger" (click)="doHardDelete(h)">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button *ngIf="mode === 'edit' && habit && !habit.archivedAt"
              type="button" class="btn-danger" (click)="doArchive()">Archive</button>
      <button type="button" class="btn-secondary" (click)="close.emit()">Cancel</button>
      <button type="button" class="btn-primary" (click)="doSave()">Save</button>
    </div>
  </div>
</div>
